export const servicePaymentmethods = [
	// Банковские карты
	{
		name: 'Онлайн-оплата банковской картой',
		location: 'Способы оплаты: Банковские карты',
		url: '/payments/cards#block1',
	},
	{
		name: 'Платежные системы и методы',
		location: 'Способы оплаты: Банковские карты',
		url: '/payments/cards#block2',
	},
	{
		name: 'Visa',
		location: 'Способы оплаты: Банковские карты',
		url: '/payments/cards#block2Title1',
	},
	{
		name: 'Mastercard',
		location: 'Способы оплаты: Банковские карты',
		url: '/payments/cards#block2Title2',
	},
	{
		name: '&laquo;Мир&raquo;',
		location: 'Способы оплаты: Банковские карты',
		url: '/payments/cards#block2Title3',
	},
	// Иностранные карты
	{
		name: 'Оплата иностранными картами',
		location: 'Способы оплаты: Иностранные карты',
		url: '/payments/foreign-cards#block1',
	},
	{
		name: 'Преимущества оплаты иностранными картами CloudPayments',
		location: 'Способы оплаты: Иностранные карты',
		url: '/payments/foreign-cards#block2',
	},
	{
		name: 'Кому подойдет оплата иностранными картами',
		location: 'Способы оплаты: Иностранные карты',
		url: '/payments/foreign-cards#block3',
	},
	{
		name: 'Как подключить прием платежей с иностранных карт',
		location: 'Способы оплаты: Иностранные карты',
		url: '/payments/foreign-cards#block4',
	},
	{
		name: 'FAQ',
		location: 'Способы оплаты: Иностранные карты',
		url: '/payments/foreign-cards#block5',
	},
	{
		name: 'Какие есть лимиты по сумме платежа?',
		location: 'Способы оплаты: Иностранные карты',
		url: '/payments/foreign-cards#block5Title1',
	},
	{
		name: 'Есть&nbsp;ли ограничения по&nbsp;странам эмитентов?',
		location: 'Способы оплаты: Иностранные карты',
		url: '/payments/foreign-cards#block5Title2',
	},
	{
		name: 'Нужна ли фискализация для приема платежей из-за границы?',
		location: 'Способы оплаты: Иностранные карты',
		url: '/payments/foreign-cards#block5Title3',
	},
	{
		name: 'На какие сайты можно подключить прием международных платежей?',
		location: 'Способы оплаты: Иностранные карты',
		url: '/payments/foreign-cards#block5Title4',
	},
	{
		name: 'Какие устройства поддерживают оплату иностранной картой?',
		location: 'Способы оплаты: Иностранные карты',
		url: '/payments/foreign-cards#block5Title5',
	},
	// {
	// 	name: 'Apple Pay',
	// 	location: 'Способы оплаты: Банковские карты',
	// 	url: '/payments/cards#block2Title4',
	// },
	// {
	// 	name: 'Google Pay',
	// 	location: 'Способы оплаты: Банковские карты',
	// 	url: '/payments/cards#block2Title5',
	// },
	{
		name: 'Как работает оплата картой на сайте',
		location: 'Способы оплаты: Банковские карты',
		url: '/payments/cards#block3',
	},
	{
		name: 'Оплата картой в приложении',
		location: 'Способы оплаты: Банковские карты',
		url: '/payments/cards#block4',
	},
	{
		name: 'Оплата картой по ссылке',
		location: 'Способы оплаты: Банковские карты',
		url: '/payments/cards#block5',
	},
	{
		name: 'Как подключить оплату банковскими картами?',
		location: 'Способы оплаты: Банковские карты',
		url: '/payments/cards#block6',
	},
	{
		name: 'FAQ',
		location: 'Способы оплаты: Банковские карты',
		url: '/payments/cards#block7',
	},
	{
		name: 'Нужно ли пробивать чеки при оплате через сайт или приложение?',
		location: 'Способы оплаты: Банковские карты',
		url: '/payments/cards#block7Title1',
	},
	{
		name: 'Как сделать сайт или приложение с возможностью оплаты картой?',
		location: 'Способы оплаты: Банковские карты',
		url: '/payments/cards#block7Title2',
	},
	{
		name: 'Как работают онлайн-платежи на сайте для продавца?',
		location: 'Способы оплаты: Банковские карты',
		url: '/payments/cards#block7Title3',
	},

	// Tinkoff pay
	{
		name: 'T-Pay',
		location: 'Pay-сервисы: T-Pay',
		url: '/pay-services/t-pay#block1',
	},
	{
		name: 'Как интегрировать оплату через T-Pay',
		location: 'Pay-сервисы: T-Pay',
		url: '/pay-services/t-pay#block2',
	},
	{
		name: 'Порядок действий для включения T-Pay на вашем веб-ресурсе:',
		location: 'Pay-сервисы: T-Pay',
		url: '/pay-services/t-pay#block2Title1',
	},
	{
		name: 'Шаги для интеграции T-Pay в мобильном приложении:',
		location: 'Pay-сервисы: T-Pay',
		url: '/pay-services/t-pay#block2Title2',
	},
	{
		name: 'Если вы планируете разместить кнопку T-Pay самостоятельно:',
		location: 'Pay-сервисы: T-Pay',
		url: '/pay-services/t-pay#block2Title4',
	},
	{
		name: 'FAQ',
		location: 'Pay-сервисы: T-Pay',
		url: '/pay-services/t-pay#block3',
	},
	{
		name: 'На каких веб-ресурсах можно включить T-Pay?',
		location: 'Pay-сервисы: T-Pay',
		url: '/pay-services/t-pay#block-faq-1',
	},
	{
		name: 'Какие устройства поддерживают T-Pay?',
		location: 'Pay-сервисы: T-Pay',
		url: '/pay-services/t-pay#block-faq-2',
	},
	{
		name: 'Как обрабатываются возвраты платежей, сделанных через T-Pay?',
		location: 'Pay-сервисы: T-Pay',
		url: '/pay-services/t-pay#block-faq-3',
	},
	{
		name: 'Требуются ли отдельные настройки для квитанций (54-ФЗ) при использовании T-Pay?',
		location: 'Pay-сервисы: T-Pay',
		url: '/pay-services/t-pay#block-faq-4',
	},
	{
		name: 'Совместим ли T-Pay с WordPress?',
		location: 'Pay-сервисы: T-Pay',
		url: '/pay-services/t-pay#block-faq-5',
	},

	// Sber pay
	{
		name: 'SberPay',
		location: 'Pay-сервисы: SberPay',
		url: '/pay-services/sber-pay#block1',
	},
	{
		name: 'Как проходит оплата через SberPay',
		location: 'Pay-сервисы: SberPay',
		url: '/pay-services/sber-pay#block2',
	},
	{
		name: 'Как интегрировать оплату через SberPay',
		location: 'Pay-сервисы: SberPay',
		url: '/pay-services/sber-pay#block2Title1',
	},
	{
		name: 'Как подключить прием платежей SberPay на вашем сайте:',
		location: 'Pay-сервисы: SberPay',
		url: '/pay-services/sber-pay#block2Title2',
	},
	{
		name: 'Как интегрировать SberPay в мобильное приложение:',
		location: 'Pay-сервисы: SberPay',
		url: '/pay-services/sber-pay#block2Title3',
	},
	{
		name: 'Если вы планируете разместить кнопку SberPay самостоятельно:',
		location: 'Pay-сервисы: SberPay',
		url: '/pay-services/sber-pay#block2Title4',
	},
	{
		name: 'FAQ',
		location: 'Pay-сервисы: SberPay',
		url: '/pay-services/sber-pay#block3',
	},
	{
		name: 'На каких ресурсах можно включить SberPay?',
		location: 'Pay-сервисы: SberPay',
		url: '/pay-services/sber-pay#block-faq-1',
	},
	{
		name: 'Какие устройства поддерживают SberPay?',
		location: 'Pay-сервисы: SberPay',
		url: '/pay-services/sber-pay#block-faq-2',
	},
	{
		name: 'Как обрабатываются возвраты платежей, сделанных через SberPay?',
		location: 'Pay-сервисы: SberPay',
		url: '/pay-services/sber-pay#block-faq-3',
	},
	{
		name: 'Нужна ли отдельная настройка для квитанций (54-ФЗ) при использовании SberPay?',
		location: 'Pay-сервисы: SberPay',
		url: '/pay-services/sber-pay#block-faq-4',
	},
	{
		name: 'Совместим ли SberPay с WordPress?',
		location: 'Pay-сервисы: SberPay',
		url: '/pay-services/sber-pay#block-faq-5',
	},

	// mir pay
	{
		name: 'Mir Pay',
		location: 'Pay-сервисы: Mir Pay',
		url: '/pay-services/mir-pay',
	},
	{
		name: 'Как оплачивать покупки с Mir Pay',
		location: 'Pay-сервисы: Mir Pay',
		url: '/pay-services/mir-pay#block2',
	},
	{
		name: 'FAQ',
		location: 'Pay-сервисы: Mir Pay',
		url: '/pay-services/mir-pay#block3',
	},
	{
		name: 'На каких веб-ресурсах можно включить Mir Pay?',
		location: 'Pay-сервисы: Mir Pay',
		url: '/pay-services/mir-pay#block-faq-1',
	},
	{
		name: 'Какие устройства поддерживают Mir Pay?',
		location: 'Pay-сервисы: Mir Pay',
		url: '/pay-services/mir-pay#block-faq-2',
	},
	{
		name: 'Требуются ли отдельные настройки для квитанций (54-ФЗ) при использовании Mir Pay?',
		location: 'Pay-сервисы: Mir Pay',
		url: '/pay-services/mir-pay#block-faq-3',
	},

	// sbp
	{
		name: 'СБП',
		location: 'Способы оплаты: СБП',
		url: '/pay-services/sbp',
	},
	{
		name: 'Что такое СБП',
		location: 'Способы оплаты: СБП',
		url: '/pay-services/sbp#block2',
	},
	{
		name: 'Преимущества использования СБП',
		location: 'Способы оплаты: СБП',
		url: '/pay-services/sbp#block3',
	},
	{
		name: 'Как подключить СБП на сайте или в приложении:',
		location: 'Способы оплаты: СБП',
		url: '/pay-services/sbp#block4',
	},
	{
		name: 'FAQ',
		location: 'Способы оплаты: СБП',
		url: '/pay-services/sbp#block5',
	},
	{
		name: 'На какие сайты можно подключить прием платежей через СБП?',
		location: 'Способы оплаты: СБП',
		url: '/pay-services/sbp#block-faq-1',
	},
	{
		name: 'Какие устройства поддерживают платежный сервис СБП?',
		location: 'Способы оплаты: СБП',
		url: '/pay-services/sbp#block-faq-2',
	},
	{
		name: 'Как работает возврат платежей, совершенных через Paу-сервис СБП?',
		location: 'Способы оплаты: СБП',
		url: '/pay-services/sbp#block-faq-3',
	},
	{
		name: 'При приеме платежей через СБП нужны отдельные настройки чеков (54-ФЗ)?',
		location: 'Способы оплаты: СБП',
		url: '/pay-services/sbp#block-faq-4',
	},
	{
		name: 'Работает ли система быстрых платежей на WordPress?',
		location: 'Способы оплаты: СБП',
		url: '/pay-services/sbp#block-faq-5',
	},

	// Оплата в рассрочку
	{
		name: 'Рассрочка',
		location: 'Способы оплаты: Рассрочка',
		url: '/payments/credit#block1',
	},
	{
		name: 'Прием платежей в кредит',
		location: 'Способы оплаты: Рассрочка',
		url: '/payments/credit#block1',
	},
	{
		name: 'Как подключить оплату по частям?',
		location: 'Способы оплаты: Рассрочка',
		url: '/payments/credit#block2',
	},
	{
		name: 'Условия для покупателя',
		location: 'Способы оплаты: Рассрочка',
		url: '/payments/credit#block3',
	},
	{
		name: 'Платежи по частям доступны всем покупателям онлайн-магазинов',
		location: 'Способы оплаты: Рассрочка',
		url: '/payments/credit#block3Title1',
	},
	{
		name: 'Условия',
		location: 'Способы оплаты: Рассрочка',
		url: '/payments/credit#block3Title2',
	},
	{
		name: 'Преимущества',
		location: 'Способы оплаты: Рассрочка',
		url: '/payments/credit#block4',
	},
];
